'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyPolicyEn = function (_React$Component) {
    _inherits(PrivacyPolicyEn, _React$Component);

    function PrivacyPolicyEn() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PrivacyPolicyEn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivacyPolicyEn.__proto__ || Object.getPrototypeOf(PrivacyPolicyEn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            companyEnName: 'Beijing Xiaowei Cloud Service Technology Co., Ltd.',
            companyName: 'Beijing Xiaowei Cloud Inc.'
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PrivacyPolicyEn, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = '小微便簽-隱私協議';
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            '\u5C0F\u5FAE\u4FBF\u7C3D'
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'eula' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'title' },
                        '\u96B1\u79C1\u5354\u8B70'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u672C\u5354\u8B70\u66F4\u65B0\u65BC2023\u5E747\u670825\u65E5'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u96B1\u79C1\u4FDD\u8B77\u8072\u660E'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u672C\u6587\u6A94\uFF08\u201C\u5C0F\u5FAE\u4FBF\u7C3D\u96B1\u79C1\u5354\u8B70\u201D\uFF09\u89E3\u91CB\u4E86\u9069\u7528\u65BC\u60A8\u8A2A\u554F\u3001\u5B89\u88DD\u6216\u4F7F\u7528\u6211\u5011\u7684\u61C9\u7528\u7A0B\u5E8F\u548C\u670D\u52D9\u6642\u6536\u96C6\u6216\u63D0\u4EA4\u7684\u6240\u6709\u4FE1\u606F\u7684\u96B1\u79C1\u5354\u8B70\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u901A\u904E\u8A2A\u554F\u6211\u5011\u7684\u7DB2\u7AD9\u3001\u5411\u6211\u5011\u63D0\u4EA4\u60A8\u7684\u500B\u4EBA\u6578\u64DA\u3001\u8A2A\u554F\u3001\u5B89\u88DD\u548C/\u6216\u4F7F\u7528\u670D\u52D9\uFF0C\u60A8\u78BA\u8A8D\u60A8\u5DF2\u95B1\u8B80\u672C\u96B1\u79C1\u653F\u7B56\u4E26\u540C\u610F\u53D7\u672C\u96B1\u79C1\u653F\u7B56\u7684\u689D\u6B3E\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u96B1\u79C1\u653F\u7B56\u7684\u4EFB\u4F55\u689D\u6B3E\uFF0C\u8ACB\u505C\u6B62\u4F7F\u7528\u6211\u5011\u7684\u670D\u52D9\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u6570\u636E\u5904\u7406'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u6211\u4EEC\u5728\u6709\u9650\u7684\u8303\u56F4\u5185\u5904\u7406\u7528\u6237\u6570\u636E-\u7528\u4E8E\u63D0\u4F9B\u670D\u52A1\u3001\u5904\u7406\u670D\u52A1\u652F\u4ED8\u4EE5\u53CA\u6211\u4EEC\u7684\u7F51\u7AD9\u548C\u79FB\u52A8\u5E94\u7528\u7A0B\u5E8F\u7684\u529F\u80FD\u3002\u6211\u4EEC\u5904\u7406\u4EE5\u4E0B\u57FA\u672C\u4FE1\u606F\uFF1A'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u5275\u5EFA\u5E33\u6236\u7684\u4FE1\u606F'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF1A\u5982\u679C\u4F60\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u4F5C\u70BA\u8CEC\u6236\u4FE1\u606F\uFF0C\u6211\u5011\u5C07\u4F7F\u7528\u5B83\u70BA\u60A8\u5EFA\u7ACB\u4E00\u500B\u5E33\u6236\uFF0C\u540C\u6642\u80FD\u5229\u7528\u5B83\u5E6B\u4F60\u627E\u56DE\u907A\u5FD8\u7684\u5BC6\u78BC\u3002\u76EE\u524D\uFF0C\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u4F5C\u70BA\u8CEC\u6236\u4E0D\u662F\u4E00\u5B9A\u5FC5\u8981\u7684\u3002\u4F60\u4E5F\u53EF\u4EE5\u4E0D\u4F7F\u7528\u96FB\u5B50\u90F5\u7BB1\u4F5C\u70BA\u8CEC\u6236\uFF0C\u9019\u6703\u63D0\u5347\u4F60\u7684\u96B1\u79C1\u6027\uFF0C\u4F46\u662F\u5728\u9019\u7A2E\u60C5\u6CC1\u4E0B\u6211\u5011\u5C07\u7121\u6CD5\u5E6B\u52A9\u4F60\u627E\u56DE\u907A\u5FD8\u7684\u5BC6\u78BC\u3002\u5728\u9019\u7A2E\u60C5\u6CC1\uFF08\u907A\u5FD8\u5BC6\u78BC\uFF09\u4E0B\uFF0C\u4F60\u5C07\u6C38\u9060\u8A66\u53BB\u4F60\u7684\u6703\u54E1\u6B0A\u76CA\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u652F\u4ED8\u76F8\u95DC\u4FE1\u606F'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u652F\u4ED8\u6578\u64DA\uFF08\u5982\u679C\u60A8\u4F7F\u7528\u4ED8\u8CBB\u670D\u52D9\u7684\u8A71\uFF09\uFF1A\u9019\u4E9B\u4FE1\u606F\u662F\u70BA\u6211\u5011\u7684\u670D\u52D9\u6536\u53D6\u8CBB\u7528\u6240\u5FC5\u9700\u7684\u3002\u6211\u5011\u7684\u652F\u4ED8\u8655\u7406\u5408\u4F5C\u5925\u4F34\u8655\u7406\u652F\u4ED8\u8655\u7406\u548C\u9000\u6B3E\u8ACB\u6C42\u7684\u57FA\u672C\u5E33\u55AE\u4FE1\u606F\uFF08\u5982\u8CFC\u8CB7\u65E5\u671F\u3001\u4ED8\u6B3E\u4EBA\u7684IP\u5730\u5740\u3001\u90F5\u653F\u7DE8\u78BC\u3001\u9280\u884C\u5361\u6240\u6709\u4EBA\u7684\u5168\u540D\u548C\u4FE1\u7528\u5361\u4FE1\u606F\uFF09\u3002\u5728\u5B8C\u6210\u4ED8\u6B3E\u7684\u60C5\u6CC1\u4E0B\uFF0C\u6211\u5011\u4E5F\u6703\u81EA\u5DF1\u8655\u7406\u4E00\u4E9B\u76F8\u540C\u7684\u4ED8\u6B3E\u4FE1\u606F\uFF08\u4F8B\u5982\uFF0C\u8A02\u55AEid\u3001IP\u5730\u5740\u3001\u7E3D\u91D1\u984D\u7B49\u7B49\uFF09\uFF0C\u6211\u5011\u5C07\u6703\u6301\u7E8C\u8A18\u9304\u9019\u4E9B\u4FE1\u606F\u4E00\u6BB5\u6642\u9593\uFF0C\u4EE5\u78BA\u4FDD\u670D\u52D9\u7684\u5B8C\u6210\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u901A\u4FE1\u6578\u64DA'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u8A2D\u5099\u4FE1\u606F\uFF1A\u7576\u60A8\u8A2A\u554F\u6211\u5011\u7684\u7DB2\u7AD9\u6642\uFF0C\u6211\u5011\u4E5F\u6703\u5728\u61C9\u7528\u7A0B\u5E8F\u4E2D\u6536\u96C6\u4E00\u4E9B\u8A2D\u5099\u4FE1\u606F\u3002\u9019\u4E9B\u4FE1\u606F\u662F\u81EA\u52D5\u8A18\u9304\u7684\uFF0C\u53EF\u80FD\u5305\u62EC\u8A2D\u5099\u578B\u865F\u3001\u64CD\u4F5C\u7CFB\u7D71\u7248\u672C\u548C\u985E\u4F3C\u7684\u975E\u8B58\u5225\u4FE1\u606F\u3002\u6211\u5011\u53EF\u80FD\u4F7F\u7528\u9019\u4E9B\u4FE1\u606F\u4F86\u76E3\u63A7\u3001\u958B\u767C\u548C\u5206\u6790\u6211\u5011\u670D\u52D9\u7684\u4F7F\u7528\u60C5\u6CC1\u3002 ',
                        _react2["default"].createElement('br', null),
                        '\u8A2D\u5099\u6A19\u8B58\u7B26\uFF1A\u5728\u67D0\u4E9B\u60C5\u6CC1\u4E0B\uFF0C\u6211\u5011\u53EF\u80FD\u6703\u8A18\u9304\u60A8\u7684\u79FB\u52D5\u8A2D\u5099\u7684\u6A19\u8B58\u7B26\uFF0C\u4EE5\u7528\u65BC\u71DF\u92B7\u6216\u5206\u6790\u76EE\u7684\u3002 ',
                        _react2["default"].createElement('br', null),
                        '\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF1A\u5982\u679C\u60A8\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u4F5C\u70BA\u7528\u6236\u540D\uFF0C\u6211\u5011\u5C07\u4F7F\u7528\u5B83\u4F86\u6A19\u8B58\u60A8\u7684\u6703\u54E1\u6B0A\u76CA\u3002 ',
                        _react2["default"].createElement('br', null),
                        '\u901A\u4FE1\u512A\u5316\u6578\u64DA\uFF1A\u6211\u5011\u4F7F\u7528\u5404\u7A2E\u5DE5\u5177\u4F86\u5E6B\u52A9\u6211\u5011\u512A\u5316\u6211\u5011\u7684\u7DB2\u7D61\u670D\u52D9\u3002\u6211\u5011\u53EF\u4EE5\u770B\u5230\u7528\u6236\u8A2D\u5099\u7684\u64CD\u4F5C\u7CFB\u7D71\uFF08\u5982Windows\u3001Mac\u3001iOS\u3001Android\uFF09\u4FE1\u606F\u548CIP\u5730\u5740\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u7DB2\u7AD9\u4E0A\u6536\u96C6\u7684\u4FE1\u606F'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u8A2A\u554F\u65E5\u8A8C\uFF1A\u4F5C\u70BA\u4E92\u806F\u7DB2\u4E0A\u7684\u5927\u591A\u6578\u7DB2\u7AD9\uFF0C\u90FD\u5C07\u81EA\u52D5\u6536\u96C6\u8A2A\u554F\u65E5\u8A8C\uFF08\u5982IP\u5730\u5740\u3001\u700F\u89BD\u5668\u985E\u578B\u3001\u64CD\u4F5C\u7CFB\u7D71\uFF09\u4EE5\u904B\u884C\u6211\u5011\u7684\u670D\u52D9\u7A2E\u985E\u3002\u9019\u4E9B\u4FE1\u606F\u5C0D\u65BC\u62B5\u79A6DDoS\u653B\u64CA\u3001\u6383\u63CF\u548C\u985E\u4F3C\u7684\u9ED1\u5BA2\u653B\u64CA\u4E5F\u662F\u5FC5\u4E0D\u53EF\u5C11\u7684\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u5171\u4EAB\u60A8\u7684\u500B\u4EBA\u6578\u64DA'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u6211\u5011\u4E0D\u8207\u7B2C\u4E09\u65B9\u5171\u4EAB\u60A8\u7684\u500B\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u672C\u96B1\u79C1\u653F\u7B56\u4E2D\u6709\u8AAA\u660E\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u6578\u64DA\u5B89\u5168'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u6211\u5011\u975E\u5E38\u91CD\u8996\u6578\u64DA\u5B89\u5168\uFF0C\u4E26\u63A1\u53D6\u4E00\u5207\u5408\u7406\u5FC5\u8981\u7684\u63AA\u65BD\u4FDD\u8B77\u60A8\u7684\u6578\u64DA\uFF08\u7121\u8AD6\u662F\u6280\u8853\u3001\u7269\u7406\u9084\u662F\u7BA1\u7406\uFF09\u3002\u7136\u800C\uFF0C\u6C92\u6709\u54EA\u5BB6\u516C\u53F8\u80FD\u5920\u4FDD\u8B49\u4E92\u806F\u7DB2\u901A\u4FE1\u7684\u7D55\u5C0D\u5B89\u5168\u3002\u901A\u904E\u4F7F\u7528\u672C\u670D\u52D9\uFF0C\u60A8\u660E\u78BA\u627F\u8A8D\uFF0C\u6211\u5011\u7121\u6CD5\u4FDD\u8B49\u901A\u904E\u672C\u670D\u52D9\u5411\u60A8\u63D0\u4F9B\u7D55\u5C0D\u7684\u6578\u64DA\u5B89\u5168\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u4F7F\u7528\u7B2C\u4E09\u65B9SDK'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u70BA\u4E86\u4FDD\u969C\u5E73\u53F0\u7684\u904B\u71DF\u7A69\u5B9A\u5B89\u5168\uFF0C\u6211\u5011\u4F7F\u7528\u53CB\u76DF+SDK\uFF0C\u5728\u60A8\u6388\u6B0A\u540C\u610F\u5F8C\uFF0C\u5411\u60A8\u7372\u53D6\u8A2A\u554F\u60A8\u7684\u672C\u6A5F\u8A2D\u5099\u4FE1\u606F\u3001MAC\u5730\u5740\u53CA\u670D\u52D9\u529F\u80FD\u7684\u4F7F\u7528\u983B\u6B21\u6B0A\u9650\u3002\u5982\u4E0D\u6388\u6B0A\uFF0C\u6709\u53EF\u80FD\u6703\u5F71\u97FF\u670D\u52D9\u7684\u5B89\u5168\u6027\u4EE5\u53CA\u60A8\u53EF\u80FD\u7121\u6CD5\u5F97\u5230\u512A\u8CEA\u7684\u7528\u6236\u9AD4\u9A57\u3002\u60A8\u53EF\u4EE5\u8A2A\u554F https://www.umeng.com/policy \u4E86\u89E3\u3010\u53CB\u76DF+\u3011\u96B1\u79C1\u6B0A\u653F\u7B56\u3002'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        '\u806F\u7E6B\u6211\u5011'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        '\u5982\u679C\u60A8\u6709\u95DC\u65BC\u672C\u96B1\u79C1\u653F\u7B56\u7684\u4EFB\u4F55\u554F\u984C\u6216\u7591\u616E\uFF0C\u8ACB\u767C\u9001\u90F5\u4EF6\u5230\uFF1Aservice@xiaoweiyunfu.com'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'part' },
                        this.state.companyName
                    ),
                    _react2["default"].createElement('div', { className: 'part' })
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    '\u5BA2\u6236\u652F\u6301'
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    '\u5982\u679C\u60A8\u6709\u4EFB\u4F55\u610F\u898B\u548C\u5EFA\u8B70\uFF0C\u656C\u8ACB\u90F5\u4EF6\u806F\u7E6B\u6211\u5011',
                                    _react2["default"].createElement('br', null),
                                    'service@xiaoweiyunfu.com'
                                )
                            ),
                            _react2["default"].createElement('div', { className: 'left' })
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            'Copyright \xA9 2023 ',
                            this.state.companyEnName,
                            '  \xA0\xA0 ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicyen' },
                                'Privacy Policy'
                            ),
                            ' '
                        )
                    )
                )
            );
        }
    }]);

    return PrivacyPolicyEn;
}(_react2["default"].Component);

exports["default"] = PrivacyPolicyEn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./PrivacyPolicyTw.js
// module id = 386
// module chunks = 0